import { api } from './requestGraphql.js';

const getPaymentInfo = async () => {
    try {
        const res = await api.post(
            '',
            {
                query: `{
                         getPaymentInfo{
                            terms{
                              id
                              name
                            }
                            methods{
                              id
                              name
                            }
                          }
                        }
                `,
            }
        );
        const response = res.data.data.getPaymentInfo;
        // console.log(response)
        // console.log(`getLidInfo response count:`, response.length);
        return response;
    } catch (e) {
        console.log(e);
    }
};

export default {
    getPaymentInfo,
}